import { render, staticRenderFns } from "./StepFormBuilder.vue?vue&type=template&id=c00ac32c&scoped=true&"
import script from "./StepFormBuilder.vue?vue&type=script&lang=js&"
export * from "./StepFormBuilder.vue?vue&type=script&lang=js&"
import style0 from "./StepFormBuilder.vue?vue&type=style&index=0&id=c00ac32c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00ac32c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c00ac32c')) {
      api.createRecord('c00ac32c', component.options)
    } else {
      api.reload('c00ac32c', component.options)
    }
    module.hot.accept("./StepFormBuilder.vue?vue&type=template&id=c00ac32c&scoped=true&", function () {
      api.rerender('c00ac32c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/wizardFlow/wizard/flow/StepFormBuilder.vue"
export default component.exports